module.exports = __webpack_public_path__ + "static/media/pattern_alchemy.67868075.gif";